import React, { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { InputProps } from "./types";
import { isValidEmail } from "./utils";
import Label from "./label";
import styles from "./styles";

export const RefInput = (props: InputProps) => {
    const {
        name,
        label,
        cssName,
        labelCssName,
        fieldOptions = {},
        customValidationMessage,
        type = "text",
        placeHolder,
        mRef,
        justControl = false
    } = props;

    const hasRun = useRef<boolean>(false);

    const _name = name.toString();

    const { register, setValue, getValues, trigger, formState: { errors } } = useFormContext();

    const registerHook = register(name.toString(), fieldOptions);

    const handleEmailValidation = (value: string) => isValidEmail(value);

    if (type === "email") {
        fieldOptions.validate = {
            checkEmail: (value) => handleEmailValidation(value) || customValidationMessage
        };
    }

    //Note label comes after input but to BS floating labels

    const updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(_name, e.target.value.toString());
        trigger([_name]);
    }

    useEffect(() => {
        if (hasRun.current) {
            return;
        }

        const input = mRef as any;

        if (!input) {
            return;
        }

        input.current.value = getValues(_name);
        hasRun.current = true;
    }, [hasRun])

    if (justControl) {
        return <input
            id={_name}
            type={type}
            onChange={updateValue}
            //onChange={registerHook.onChange}
            onBlur={registerHook.onBlur}
            name={registerHook.name}
            ref={mRef} />
    }

    return (<div className={cssName}>
        <input
            id={_name}
            type={type}
            onChange={updateValue}
            //onChange={registerHook.onChange}
            onBlur={registerHook.onBlur}
            name={registerHook.name}
            ref={mRef}
            className={styles.elements.input}
            placeholder={placeHolder ?? label} />

        <Label htmlFor={_name} text={label} cssName={labelCssName} />

        <ErrorMessage
            errors={errors}
            name={_name}
            render={({ message }) => <p className="error">{message}</p>}
        />
    </div>);
}

export default RefInput;